import React, { Component } from 'react'
import Link from 'react-router/lib/Link'
import { LocalForm, Control } from 'react-redux-form'
import { Fieldset, Row, Field } from 'react-gridforms'
import isEmail from 'validator/lib/isEmail'

class FormForgot extends Component {

  constructor(props) {
    super(props)
    this.state = {
      valid: false,
    }
  }

  _onUpdate = (form) => {
    this.setState({
      valid: form.$form.valid,
    })
  }

  render() {
    const { valid } = this.state
    const { onSubmit, pending } = this.props

    return (
      <LocalForm
        onSubmit={onSubmit}
        disabled={pending}
        className="grid-form"
        onUpdate={this._onUpdate}
      >
        <Fieldset legend="Forgot Password:" disabled={pending}>
          <Row>
            <Field>
              <label htmlFor="email">Email Address <span className="req">*</span></label>
              <Control.text
                model=".email"
                className="form-control"
                validators={{
                  isEmail: (val) => val && isEmail(val + ''),
                }}
                autoFocus
              />
            </Field>
          </Row>
          <p className="m-t-20 text-right">
            <Link to="/login" className="btn-link"><em>&larr; Back to Login</em></Link>{' '}
            <button type="submit" disabled={!valid} className="btn btn-info">Send Code</button>
          </p>
        </Fieldset>
      </LocalForm>
    )
  }
}

export default FormForgot



// WEBPACK FOOTER //
// ./src/containers/Auth/ForgotPassword/form-forgot.js